import { render, staticRenderFns } from "./VistaCliente.vue?vue&type=template&id=1cc6dfba&lang=pug&"
import script from "./VistaCliente.vue?vue&type=script&lang=js&"
export * from "./VistaCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports